define([
    "./tripOperationHistoryModule",
    "./tripOperationHistoryModal",
    "./tripOperationHistoryService",
    "./tripOperationHistoryServiceUrl",
], function (){
});